import { DateRangeEntry } from "../types";
import { createDateRangeSelectionHandler } from "../utils/createDateRangeSelectionHandler";

import { AnalyticsChartInterval } from "@/queries/useRequestAnalytics";

export interface DateChartSelection {
  dateEntries: DateRangeEntry[];
  dateRange: { from: Date; to: Date };
  chartInterval: AnalyticsChartInterval;
  onDateRangeSelect: (range: { from: Date; to: Date }) => void;
}

export const buildDateChartSelectionOptions = (selection?: DateChartSelection) => ({
  zoom: selection
    ? {
        enabled: true,
        axes: "x" as const,
        enableSelecting: true,
        enableAxisDragging: false,
        enablePanning: false,
        enableScrolling: false,
        buttons: {
          enabled: false,
        },
      }
    : undefined,
  listeners: selection
    ? {
        zoom: createDateRangeSelectionHandler(
          selection.dateEntries,
          selection.dateRange,
          selection.chartInterval,
          selection.onDateRangeSelect,
        ),
      }
    : undefined,
});
